export default {
  title: { id: 'title' },
  dateCreated: { id: 'date_created' },
  actions: { id: 'actions' },
  pdfDownload: { id: 'pdf_download' },
  search: { id: 'search' },
  noData: { id: 'no_data' },
}
